import React from 'react';
import TablaTerritorios_CuerpoFilaTerritorio from './TablaTerritorios_CuerpoFilaTerritorio';

const TablaTerritorios_Cuerpo = ({data}) => {
    return(
        <tbody>
        {data.mapagan?.map(partidoGanador => {
          return(<TablaTerritorios_CuerpoFilaTerritorio data={partidoGanador} />)
      })}
    </tbody>
    );
};

export default TablaTerritorios_Cuerpo;